import { Outlet, useOutletContext } from 'react-router-dom'

import { CostCentersList } from 'modules/cost_centers/components/CostCenterList'
import { CostCentersStructure } from 'modules/cost_centers/components/CostCentersStructure'

const CostCentersListPage = () => {
  const { canManageCostCenters, hasNewStructureEnabled, hasFeatureCostCenterManagement } = useOutletContext<{
    canManageCostCenters: boolean
    hasNewStructureEnabled: boolean
    hasFeatureCostCenterManagement: boolean
  }>()

  return (
    <>
      {hasNewStructureEnabled ? <CostCentersStructure /> : <CostCentersList canManageCostCenters={canManageCostCenters} />}
      <Outlet
        context={{
          canManageCostCenters,
          hasFeatureCostCenterManagement,
        }}
      />
    </>
  )
}

export default CostCentersListPage
